module.exports = __webpack_public_path__ + "static/media/footerArrow.d3dba0ba.svg";